import { render, staticRenderFns } from "./document-link.vue?vue&type=template&id=620674f6&"
import script from "./document-link.vue?vue&type=script&lang=js&"
export * from "./document-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports